import styled from "styled-components";

export default styled.p`
  font-family: "UniversCondensed", sans-serif;
  margin: 0 0 20px;
`;
